<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"/>
    <loading :loading="isLoading">
      <error :error="error"/>
      <b-tabs small pills>
        <b-tab v-for="ruleName in ruleNames" :key="ruleName" :title="stats[ruleName][0].policy_name">
          <b-card no-body :header="stats[ruleName][0].policy_name">
            <b-table striped class="text-right" :items="stats[ruleName]" :fields="['authority', 'amount_saved', 'amount_saved_30days', 'number_of_investigations', 'number_of_misnomers']">
              <template #cell(amount_saved)="data">{{ data.value | currency }}</template>
              <template #cell(amount_saved_30days)="data">{{ data.value | currency }}</template>
              <template #cell(number_of_investigations)="data">{{ data.value | commas }}</template>
              <template #cell(number_of_misnomers)="data">{{ data.value | commas }}</template>
            </b-table>
          </b-card>
        </b-tab>
      </b-tabs>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'

export default {
  components: { Loading, Error },
  data() {
    return {
      isLoading: true,
      stats: null,
      authorities: [],
      error: null,
      breadcrumbs: [
        { text: 'Statistics', to: '/' },
        { text: 'Rule-based', active: true },
      ],
    };
  },
  computed: {
    ruleNames() {
      if (!this.stats) {
        return [];
      }
      return Object.keys(this.stats);
    },
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    return this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'StatsByRule',
    })
    .then((page) => {
      this.authorities = page.Authorities.map(a => a.authority);
      this.stats = page.Stats.reduce((a, c) => {
        // group by policy_code
        if (!a[c.policy_code]) {
          a[c.policy_code] = this.authorities.map(a => ({ authority: a, policy_name: c.policy_name }));
        }
        const index = this.authorities.indexOf(c.authority);
        a[c.policy_code][index] = c;
        return a;
      }, {});
      this.isLoading = false;
    })
    .catch(e => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
